import { get } from 'lodash';
import { createSelector } from 'reselect';
import moment from 'moment';

import { DATE_FORMAT_DATE_TIME_12H } from 'Common/Constants/dateformat';

const root = (state) => get(state, 'ManageMenuState.listCycles');

export const getGridData = (state) => get(root(state), 'gridData', []);

export const getFetching = (state) => get(root(state), 'fetching', false);

export const getFetchError = (state) => get(root(state), 'fetchError', null);

export const getFetchSharedDistrictsError = (state) =>
  get(root(state), 'fetchSharedDistrictsError', null);

export const getSaveSuccessful = (state) =>
  get(root(state), 'saveSuccessful', false);

export const getNewCycleMenu = (state) => get(root(state), 'newCycleMenu', {});

export const getEditing = (state) => get(root(state), 'editing');

export const getEditCycleValues = (state) =>
  get(root(state), 'editCycleValues');

export const getDuplicating = (state) => get(root(state), 'duplicating');

export const getDuplicateFetching = (state) =>
  get(root(state), 'duplicateFetching');

export const getShareError = (state) => get(root(state), 'shareError');

export const getUnshareError = (state) => get(root(state), 'unshareError');

export const getShareSuccessful = (state) =>
  get(root(state), 'shareSuccessful');

export const getUnshareSuccessful = (state) =>
  get(root(state), 'unshareSuccessful');

export const getSharedDistricts = (state) =>
  get(root(state), 'sharedDistricts');

export const getIsParentDistrict = (state) =>
  get(root(state), 'isParentDistrict');

export const getSharedDistrictsForSelectSitesTable = createSelector(
  getSharedDistricts,
  (sharedDistricts) => {
    return sharedDistricts.map((obj) => ({
      Id: obj.DistrictId,
      Description: obj.DistrictDescription,
      LastSharedOnDT: obj.LastSharedOnDT
        ? moment(obj.LastSharedOnDT).format(DATE_FORMAT_DATE_TIME_12H)
        : null,
    }));
  }
);



// WEBPACK FOOTER //
// ./src/pages/managemenu/state/listcycles/selectors.js